import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
  history: [],
};

const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      console.log('🔴 Redux Action: INCREMENT dispatched, current value:', state.value);
      state.value += 1;
      state.history.push({ action: 'increment', value: state.value, timestamp: Date.now() });
      console.log('🔴 Redux State: New value:', state.value);
    },
    decrement: (state) => {
      console.log('🔴 Redux Action: DECREMENT dispatched, current value:', state.value);
      state.value -= 1;
      state.history.push({ action: 'decrement', value: state.value, timestamp: Date.now() });
      console.log('🔴 Redux State: New value:', state.value);
    },
    incrementByAmount: (state, action) => {
      console.log('🔴 Redux Action: INCREMENT_BY_AMOUNT dispatched, amount:', action.payload);
      state.value += action.payload;
      state.history.push({ action: 'incrementByAmount', value: state.value, amount: action.payload, timestamp: Date.now() });
      console.log('🔴 Redux State: New value:', state.value);
    },
    reset: (state) => {
      console.log('🔴 Redux Action: RESET dispatched');
      state.value = 0;
      state.history.push({ action: 'reset', value: 0, timestamp: Date.now() });
      console.log('🔴 Redux State: Counter reset to 0');
    },
  },
});

export const { increment, decrement, incrementByAmount, reset } = counterSlice.actions;
export default counterSlice.reducer;
